/** InsCoder 2026-04-22 B + Add counter animation to title line **/
document.addEventListener('DOMContentLoaded', function() {
  var counters = document.querySelectorAll('.silk-page-text-section__title-line--primary');
  
  counters.forEach(function(el) {
    var text = el.textContent.trim();
    var match = text.match(/^(\D*)(\d+)(\D*)$/);
    if (!match) return; // If no number is found, skip animation

    var prefix = match[1];
    var countTo = parseInt(match[2], 10);
    var suffix = match[3];
    // We use a 2000ms duration instead of 8000ms for a better UX, but keeping the linear/ease effect.
    var duration = 2000; 
    var start = null;

    // Initialize with 0
    el.textContent = prefix + "0" + suffix;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = timestamp - start;
      // Calculate current value (linear, similar to provided jQuery easing:'linear')
      var current = Math.min(Math.floor((progress / duration) * countTo), countTo);
      
      el.textContent = prefix + current + suffix;
      
      if (progress < duration) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = prefix + countTo + suffix;
      }
    }

    // Use IntersectionObserver to start animation when element is in view
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          window.requestAnimationFrame(step);
          observer.disconnect();
        }
      }, {
        threshold: 0,
        rootMargin: '0px 0px -50% 0px'
      });
      observer.observe(el);
    } else {
      // Fallback
      window.requestAnimationFrame(step);
    }
  });
});
/** InsCoder 2026-04-22 E + Add counter animation to title line **/
